// Marca por dominio. Un mismo build de Amplify sirve app., demo., fesa., isseg. y
// knobloch.data-bunker.ai; lo que cambia según el dominio por el que se entra es el
// login (logos y título de la pestaña) y a qué módulo se aterriza después.
//
// Se decide por el primer segmento del hostname, así también funciona en local con
// http://knobloch.localhost:3000 (Chrome resuelve *.localhost sin tocar el hosts).
// Cualquier dominio que no esté aquí usa la marca por defecto (Data Bunker).
import logoDataBunker from '../assets/img/logo-data-new.png';
import logoKnobloch from '../assets/img/logo-knobloch.png';

// Módulos del menú, por su llave en las features del usuario (visuals sale de
// module_features; insights lo calcula el backend: ¿tiene reportes publicados?).
// Aquí sólo sirven para ocultarlos por dominio.
const MENU_MODULES = [
  'chatAgent', // AI Pricing Engine
  'powerbiReports', // Analytics Dashboards
  'mediaMonitoring',
  'priceAlerts',
  'opportunities',
  'visuals',
  'visualsDemo',
  'insights',
  'knobloch',
  'lorealPricing', // Pricing L'Oréal (sólo con el flag; en knobloch.data-bunker.ai queda oculto)
  'visualesNike', // Visuales · Nike (ídem)
  'visualesTiendasBara', // Visuales · Tiendas Bara (ídem)
  'visualesBodesa', // Visuales · Bodesa (ídem)
];

const DEFAULT_BRANDING = {
  key: 'default',
  loginLogos: [{ src: logoDataBunker, alt: 'Data Bunker' }],
  pageTitle: null,
  landing: null,
  // Módulos que en este dominio no existen (se ocultan aunque el usuario los tenga).
  // Visuales sí se ve: el backend lo prende sólo a las organizaciones con un tablero publicado.
  hiddenModules: ['knobloch'],
  // null = todos los módulos según el usuario.
  enabledModules: null,
};

const BRANDINGS = {
  knobloch: {
    key: 'knobloch',
    loginLogos: [
      { src: logoDataBunker, alt: 'Data Bunker' },
      { src: logoKnobloch, alt: 'Knobloch Information Group' },
    ],
    pageTitle: 'Knobloch × Data Bunker',
    // Al entrar por este dominio se aterriza en el módulo, si el usuario lo tiene prendido.
    landing: { path: '/knobloch', feature: 'knobloch' },
    hiddenModules: [],
    // Sólo estos se muestran (si el usuario los tiene); el resto se oculta del menú.
    enabledModules: ['chatAgent', 'powerbiReports', 'mediaMonitoring', 'knobloch'],
    // Co-branding del menú lateral: logo de Knobloch junto al de Data Bunker y el
    // isotipo de Data Bunker en la tarjeta del usuario. SÓLO para estos usuarios y
    // sólo en este dominio (los demás dominios no definen sidebarCoBrand).
    sidebarCoBrand: {
      users: ['admin-knobloch'],
      logo: { src: logoKnobloch, alt: 'Knobloch Information Group' },
      avatar: 'https://logos-amplify-data.s3.us-east-2.amazonaws.com/data-bunker.jpg',
    },
  },
};

export function resolveBranding(hostname) {
  const subdomain = (hostname || '').toLowerCase().replace(/^www\./, '').split('.')[0];
  return BRANDINGS[subdomain] || DEFAULT_BRANDING;
}

export const branding = resolveBranding(typeof window !== 'undefined' ? window.location.hostname : '');

// Módulos que el dominio oculta: los de hiddenModules, o todo lo que no esté en
// enabledModules cuando el dominio define una lista.
const HIDDEN_MODULES = new Set(branding.enabledModules
  ? MENU_MODULES.filter((key) => !branding.enabledModules.includes(key))
  : branding.hiddenModules);

// El menú no pinta estos módulos.
export const isModuleHidden = (key) => HIDDEN_MODULES.has(key);

// Co-branding del menú lateral para este usuario, o null: hace falta entrar por un
// dominio que lo defina Y ser uno de sus usuarios.
export function sidebarCoBrandFor(username) {
  const coBrand = branding.sidebarCoBrand;
  return coBrand && coBrand.users.includes(username) ? coBrand : null;
}

// Features del usuario recortadas por el dominio: los módulos ocultos quedan en
// false para que sus rutas redirijan. Nunca prende nada que el usuario no tenga.
export function applyBrandingFeatures(features) {
  const out = { ...features };
  HIDDEN_MODULES.forEach((key) => { out[key] = false; });
  return out;
}
